import AdminPanelDynamicForm from './container';

export default AdminPanelDynamicForm;
